export default __webpack_public_path__ + "static/media/ser2-1.6c905522.jpg";